import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";

type TimeShadeProps = {
  scrollParams: number[];
  timeWidth: number;
  hasFavourites: boolean;
}

const TimeShade = observer((props: TimeShadeProps) => {
  const { scrollParams, timeWidth, hasFavourites } = props;
  const [trim, setTrim] = useState(false);

  useEffect(() => {
    setTrim(hasFavourites);
  }, [hasFavourites]);

  const cssClassName = "time-shade" + (trim ? " grid-trim" : "");
  return (
    <div
      className={cssClassName}
      style={{ top: scrollParams[0], width: timeWidth }}
    ></div>
  );
});

export default TimeShade;
